import { Fragment, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import navdots from '../../../Assets/images/navdots.svg';
import TrainingStatusModal from "../RequestorManagement/TrainingStatusModal";
import ConfirmationModal from "../../ConfirmationModal";
import { FaCheckCircle, FaClock, FaNotesMedical, FaPencilAlt } from 'react-icons/fa';
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { formatDate, formatTime } from "../../../Utils/Common";
import { getStatusLabel } from "../../../Services/Donor.Service";
import CheckSentAddEdit from "./CheckSentAddEdit";
import { AdminService } from "../../../Services/Admin.service";
import OnlinePaymentComplete from "./OnlinePaymentComplete";
function DonationHistoryTableRow({ donation, handleChangeStatus, handlePaymentUpdate, fetchDonorList, sampleTypes, userType }) {
    const navigate = useNavigate();
    const handleEditDonor = () => {

        navigate(`donation-details/${donation.id}`);
    };
    // const sampleIds = donation.sample_id ? donation.sample_id.split(',').map(id => id.trim()) : [];
    const sampleIds = donation.sample_ids ? donation.sample_ids.split(',')?.map(id => id.trim()) : [];

    const [showChequeModal, setShowChequeModal] = useState(null);
    const [showOnlineModal, setShowOnlineModal] = useState(null);



    const renderPaymentStatus = (donation, onOpenChequeModal, onOpenOnlineModal) => {
        // 1️ No sample donated
        if (!donation.donor_donate_sample_id) {
            return <span>-</span>;
        }

        const { payment_method, transaction_status } = donation;

        // 2️ Transaction status is NULL
        if (!transaction_status) {
            if (payment_method === "online") {
            return (
                <Button
                variant="link"
                // className="p-0 text-warning"
                className="d-inline-flex align-items-center gap-1 text-decoration-none font-size-15"
                // className="text-decoration-none"
                onClick={() => onOpenOnlineModal(donation)}
                >
                <FaClock className="me-1" />
                Pending
                </Button>
            );
            }

            if (payment_method === "cheque") {
            return (
                <Button
                variant="link"
                // className="p-0 text-primary"
                className="d-inline-flex align-items-center gap-1 text-decoration-none font-size-15"
                onClick={() => onOpenChequeModal(donation)}
                >
                <FaPencilAlt className="me-1" />
                Check
                </Button>
            );
            }

            return <span>Not Set</span>;
        }

        // 3️ Transaction status exists
        if (transaction_status === "Check Sent") {
            return (
            <Button
                variant="link"
                // className="p-0 text-success"
                className="d-inline-flex align-items-center gap-1 text-decoration-none font-size-15"
                onClick={() => onOpenChequeModal(donation)}
            >
                {/* <FaCheckCircle className="me-1" /> */}
                 <i className="el-icon-check me-0"></i>
                Check Sent
            </Button>
            );
        }

        if (transaction_status === "Completed") {
            return (
            <span 
            className="text-success d-inline-flex align-items-center gap-1 text-decoration-none font-size-15"
            // className="text-success"
            >
                {/* <FaCheckCircle className="me-1" /> */}
                <i className="el-icon-check me-0"></i>
                Completed
            </span>
            );
        }

        return <span>{transaction_status}</span>;
        };

  

    return (
        <>
            <tr>
                <td>
                    {/* {donation.date} */}
                    {/* {new Date(donation.appointment_date).getTime() === 0
                    ? "-"
                    : new Date(donation.appointment_date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })} */}
                      {formatDate(donation.appointment_date)}
                    {/* {donation.appointment_date} */}
                </td>
                {userType!=="donation_report"  && (
                    <>
                        <td>
                            {/* {donation.time} */}
                            {/* {donation.appointment_time} */}
                            {formatTime(donation.appointment_time)}
                        </td> 
                    </>
                )}
                 {userType==="donation_report"  && (
                    <> 
                        <td>
                            {donation.name}
                        </td>
                    </>
                 )}
                <td>
                    {/* {donation.jobNumber} */}
                    {donation.job_id}
                </td>

                <td className="">
                    <div className="el-icons-bg-box">
                        {sampleIds?.length > 0 ? (
                            sampleIds?.map((sampleId) => {
                                const sampleType = sampleTypes.find((type) => type.id === sampleId);
                                return sampleType ? (


                                    <Fragment key={sampleId}>
                                        {sampleIds?.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                            key={sampleId}
                                            placement="top"
                                            overlay={
                                                <Popover id={`popover-${sampleId}`}>
                                                    <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                                </Popover>
                                            }
                                        >
                                            {/* {sampleIds.length == 1 ? (<div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.id}><i className={sampleType.className}></i> {sampleType.label}</div>) :  ( */}
                                            <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                                <i className={sampleType.className}></i>
                                            </Button>
                                            {/* )}  */}
                                        </OverlayTrigger>
                                        </>)}


                                    </Fragment>
                                ) : null;
                            })
                        ) : (
                            "No upcoming donations available"
                        )}
                    </div>
                </td>
                <td>
                    {/* <span> {`$${donation.compensation}`}</span> */}
                    <span> {`$${donation.total_price}`}</span>
                </td>
                {/* <td> 
                    <span>{`    ${donation.bloodVolume} ml - ${donation.noOfSticks} sticks `}</span>
                </td>  */}
                <td>
                    <>  
                     {/* {getStatusLabel(donation.status)} */}
                     {/* 3 is Collect ie completed */}
                        {donation.status == 3 ? (<div className="el-active"> <i className="el-icon-check me-1"></i>   {getStatusLabel(donation.status)}</div>) : (<div className="el-inactive ms-1">
                            <div className="el-inactive"></div>  {getStatusLabel(donation.status)}</div>)}
                        {/* {donation.status} */}
                    </>
                </td>

                {(userType!== 'donor'  && userType!=="donation_report" ) && (
                    <>
{/* 
{ id: 1, label: 'Accept', value: 1 },  
{ id: 2, label: 'Cancel', value: 2 },  
{ id: 3, label: 'Completed', value: 3 },  //Collect
{ id: 4, label: 'No show', value: 4 },  */}
                        
                        {/* <td>
                            {renderPaymentStatus(donation, setShowChequeModal, setShowOnlineModal)}
                        </td> */}
                        <td> 
                            {donation.status === 4 ||  donation.status === 1 ||   donation.status === 2 ?  "no-show" :  donation.on_time ||"on-time"}  
                            {/* {donation.status === 4 ? "no-show": donation.on_time ||"on-time"}   */}
                        </td>
                     
              

                <td>
                    <OverlayTrigger
                        placement="left"
                        overlay={
                            <Popover id={`popover-donation-note`}>
                                <Popover.Body>
                                    {/* {donation.donationNote?.length === 0 ? (
                                        "No note available"
                                    ) : (
                                        donation.donationNote?.map((item) => (
                                            <div key={item.id}>
                                                <strong>{item.labe}:</strong> {item.note}
                                            </div>
                                        ))
                                    )} */}
                                    {donation.notes
                                        ? donation.notes.split(",").map((note, index) => (
                                            <div
                                                key={index}
                                                dangerouslySetInnerHTML={{ __html: note.trim() }}
                                            ></div>
                                        ))
                                        : "No notes available"}
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <span>


                            <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.16165 -0.00653076H22.1617V19.9935H4.16165V-0.00653076H6.16165ZM20.1617 17.9935V1.99347H6.16165V17.9935H20.1617ZM8.16165 3.99347H18.1617V5.99347H8.16165V3.99347ZM18.1617 7.99347H8.16165V9.99347H18.1617V7.99347ZM8.16165 11.9935H15.1617V13.9935H8.16165V11.9935ZM18.1617 21.9935H2.16165V3.99347H0.161652V23.9935H18.1617V21.9935Z" fill="black" />
                            </svg>

                            {/* <FaNotesMedical style={{ cursor: 'pointer' }} /> */}
                        </span>
                    </OverlayTrigger>
                </td>
                    </>
                )}
               <td>
                {renderPaymentStatus(donation, setShowChequeModal, setShowOnlineModal)}
                </td>

                {/* <td>
                    {donor.total_donations}
                </td> */}

                {/* <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item as={Link} to={`/donor-management/donation-details/${donation.JobNumber}`} state={{ donation }}>
                                    <label>View Details</label>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td> */}
            </tr>
            <CheckSentAddEdit
                show={showChequeModal !== null}
                onHide={() => setShowChequeModal(null)}
                onConfirm={handlePaymentUpdate}
                donation={showChequeModal}
            ></CheckSentAddEdit>
            
            <OnlinePaymentComplete
                show={showOnlineModal !== null}
                onHide={() => setShowOnlineModal(null)}
                onConfirm={handlePaymentUpdate}
                donation={showOnlineModal}
            ></OnlinePaymentComplete>
        </>
    );
}
export default DonationHistoryTableRow;